import React from 'react';

const ButtonIconSimple = ({ children, disabled = false, onClick, additionalClasses = [], size = 'md' }) => {
    const classes = [...additionalClasses, 'appBtnIconSimple', `appBtnIconSimple--${size}`];

    return(
        <button onClick={onClick} disabled={disabled} type="button" className={classes.join(' ')}>
            {children}
        </button>
    )
}

export default ButtonIconSimple;